export const MESSAGE_MIGRAR_DIALOG = 'Deseja manter o follow up do possível cliente \n'
  + 'ao migra-lo para cliente?';

export const MESSAGE_GREEN_LABEL = 'Sim';

export const MESSAGE_RED_LABEL = 'Não';
